import { Component, OnInit } from "@angular/core";
import { Router } from '@angular/router';
declare var $: any;
// import * as $ from "jquery";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {

  currentYear: any;
  childrens:any;
  secondChildren:any;
  uniqueFaq_Array = [
    {
      faq_secondlevel_id: 1,
      faq_firstlevel_name: 'Support and Information',
      faq_secondlevel_name: [    
        'General Feedback',
        'Terms & Conditions'
      ]
    },
  ];
  reportMailLink ='mailto:IXDevHub.Support@accenture.com?subject=Industry X Developer Hub : Feedback&body=Hi Industry X Developer Hub Team,%0D%0A%0D%0AFollowing is the feedback I would like to share:%0D%0A< Insert feedback here >';  
  constructor(private router: Router) {
    
  }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }

  // collapseFooter(): any {
  //   setTimeout(() => {
  //     (<any>$('#menu_linkSupportandInformation')).collapse('hide');
  //     (<any>$('#menu_linkRelatedAccentureSites')).collapse('hide');
  //   });
  // }

  // secondLevelClick(names:any) {
   
   
  //   if (names == 'General Feedback') {
  //     window.open(this.reportMailLink, '_self');
  //     this.collapseFooter();
  //   }

  //   if (names == 'Terms & Conditions') {
      // this.router.navigate(['/faq']);
      // this.collapseFooter();
//     }
//   }
}
